import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import { auth } from '../../Config/auth'

import Container, { ContainerAsForm } from '../../Components/Container'
import Button from '../../Components/Button'
import Logo from '../../Components/Logo'
import { ErrorInput } from '../../Components/Input'
import { errorAction } from '../../Actions/utilsActions'

class Login extends Component {
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            password: '',
            error: false,
        }
    }

    onChange = name => e => this.setState({ [name]: e.target.value })

    login = e => {
        e.preventDefault()
        const { email, password } = this.state
        const { dispatch } = this.props

        auth.signInWithEmailAndPassword(email, password).catch(error => {
            this.setState({ error: true })
            dispatch(errorAction(error.message))
        })
    }

    render = () => {
        const {
            token,
            location: { state },
        } = this.props

        const { email, password, error } = this.state

        if (token) {
            return <Redirect to={(state && state.from) || '/'} />
        }

        return (
            <Container style={{ flex: 1 }}>
                <Logo />
                <ContainerAsForm
                    onSubmit={this.login}
                    vertical
                    alignItems="stretch"
                    style={{ width: '15em' }}
                >
                    <ErrorInput
                        value={email}
                        onChange={this.onChange('email')}
                        error={error}
                        placeholder="email"
                    />
                    <ErrorInput
                        value={password}
                        onChange={this.onChange('password')}
                        error={error}
                        placeholder="password"
                        type="password"
                    />
                    <Container style={{ flex: 1 }} justifyContent="flex-end" vertical={false}>
                        <Button type="submit">login</Button>
                    </Container>
                </ContainerAsForm>
                <Container
                    vertical={false}
                    justifyContent="space-between"
                    style={{ fontSize: '.7em', width: '21.4285714em', marginTop: '4em' }}
                >
                    <Link to="/forgot">
                        <Button style={{ color: 'rgba(147, 56, 59, 0.9' }}>
                            Forgot credentials?
                        </Button>
                    </Link>
                    <Link to="/signin">
                        <Button>Create user</Button>
                    </Link>
                </Container>
            </Container>
        )
    }
}

Login.propTypes = {
    token: PropTypes.string.isRequired,
    location: PropTypes.shape({
        state: PropTypes.shape({
            from: PropTypes.string,
        }),
    }),
    dispatch: PropTypes.func.isRequired,
}

Login.defaultProps = {
    location: {
        state: {
            from: '/',
        },
    },
}

const mapStateToProps = state => ({
    token: state.user.token,
})

export default connect(mapStateToProps)(Login)
